import { ISearchResult } from "./types";

export interface ISearchContribution {
    title: string;
    search(keyword: string): Promise<ISearchResult[]>;
}

class SearchContribContainer {
    readonly contribs: ISearchContribution[] = [];
    addContrib(contrib: ISearchContribution) {
        this.contribs.push(contrib);
    }
}

const searchContribContainer = new SearchContribContainer;
export {searchContribContainer};